import { css } from 'styled-components';
export var applyInteraction = function applyInteraction(_ref) {
  var scaleOnInteraction = _ref.scaleOnInteraction,
      scaleOnHover = _ref.scaleOnHover,
      scaleOnPress = _ref.scaleOnPress;
  return css(["transition:transform 0.1s ease-in;", " ", ""], (scaleOnHover || scaleOnInteraction) && css(["@media (hover:hover){&:hover{transform:scale(1.04);}}"]), (scaleOnPress || scaleOnInteraction) && css(["&:active{transform:scale(0.96);}"]));
};